import { computed } from "vue";
import { hasParentheses, getItalicizeLabel } from "../utils/formatting";
import { useSupplementLabelStore } from "../../stores/supplement-label-store";

export function useFormattingLabels(itemRef, nameGetter = null) {
  const store = useSupplementLabelStore();

  const getName = nameGetter || (() => itemRef.value?.name);

  const hasParens = computed(() => hasParentheses(getName()));

  const italicizeLabel = computed(() => getItalicizeLabel(getName()));

  const hideDaggerLabel = computed(() => store.hideDaggerLabel);

  return {
    hasParens,
    italicizeLabel,
    hideDaggerLabel,
  };
}
